import { enqueueSnackbar } from 'notistack';
import { useForm } from 'react-hook-form';

import { PasswordInfo, passwordService } from '../../../../services/passwordService';

type CustomerChangePasswordFormValues = PasswordInfo & { sendViaEmail: boolean };

type UseCustomerChangePasswordFormProps = {
  userId: number;
  onSuccessChange: () => void;
};

export const useCustomerChangePasswordForm = ({
  userId,
  onSuccessChange,
}: UseCustomerChangePasswordFormProps) => {
  const formMethods = useForm<CustomerChangePasswordFormValues>();
  const { handleSubmit } = formMethods;

  const handlerPasswordChange = handleSubmit(
    async ({ password, repeatPassword, sendViaEmail }) => {
      await passwordService.setNewPasswordToUser(
        userId,
        { password, repeatPassword },
        { send_password: sendViaEmail },
      );

      enqueueSnackbar('Password has been successfully changed.', { variant: 'success' });
      onSuccessChange();
    },
  );

  const validateConfirmPassword = (
    confirmPassword: string,
    formValue: CustomerChangePasswordFormValues,
  ) => confirmPassword === formValue.password || "Passwords don't match";

  return { ...formMethods, handlerPasswordChange, validateConfirmPassword };
};
